import { sortBy } from '@utils/arrays';
import { CpgRetailer } from '../api/schema';

export const OTHER_RETAILER_NAME = 'other';
export const ALL_RETAILERS_NAME = 'All Retailers';
export const MIN_RETAILER_COUNT = 10;
export const MAX_RETAILER_COUNT = 20;
const OTHER_RETAILER_LABEL = 'Remaining Retailers';

export const retailerLabel = (retailerName: string) =>
  retailerName === OTHER_RETAILER_NAME ? OTHER_RETAILER_LABEL : retailerName;

type SortableRetailer = Pick<CpgRetailer, 'name' | 'totalProjectedSales'>;

export const sortRetailers = (a: SortableRetailer, b: SortableRetailer) => {
  if (a.name === OTHER_RETAILER_NAME) return 1;
  if (b.name === OTHER_RETAILER_NAME) return -1;
  if (a.name === ALL_RETAILERS_NAME) return -1;
  if (b.name === ALL_RETAILERS_NAME) return 1;
  if (typeof a.totalProjectedSales !== 'number') return 1;
  if (typeof b.totalProjectedSales !== 'number') return -1;

  return b.totalProjectedSales - a.totalProjectedSales;
};

export const getTopRetailers = <
  T extends Pick<
    CpgRetailer,
    'totalProjectedSales' | 'statisticallySignificant' | 'name'
  >,
>(
  retailers: T[]
): T[] => {
  return retailers
    .filter(r => r.statisticallySignificant && r.name !== OTHER_RETAILER_NAME)
    .toSorted(sortBy('totalProjectedSales', 'desc'));
};

export type GroupedRetailers<T> = {
  allRetailer: T | undefined;
  topRetailers: T[];
  otherRetailer: T | undefined;
};

export const groupRetailers = <T extends Pick<CpgRetailer, 'name'>>(
  retailers: T[]
) =>
  retailers.reduce<GroupedRetailers<T>>(
    (acc, retailer) => {
      if (retailer.name === ALL_RETAILERS_NAME) {
        acc.allRetailer = retailer;
      } else if (retailer.name === OTHER_RETAILER_NAME) {
        acc.otherRetailer = retailer;
      } else {
        acc.topRetailers.push(retailer);
      }

      return acc;
    },
    { allRetailer: undefined, topRetailers: [], otherRetailer: undefined }
  );
